var _URLSearchParams$get;
export const getPortalBasename = () => {
  const metaTag = document.querySelector('meta[name="x-hs-portals-prefix"]');
  const prefix = metaTag === null || metaTag === void 0 ? void 0 : metaTag.content;
  if (!prefix) {
    return undefined;
  }
  return prefix.endsWith('/') ? prefix.slice(0, -1) : prefix;
};
export const getPortalName = () => {
  const metaTag = document.querySelector('meta[name="x-hs-portals-name"]');
  return metaTag === null || metaTag === void 0 ? void 0 : metaTag.content;
};
export function getPortalAccountId() {
  const metaTag = document.querySelector('meta[name="x-hs-portals-account-id"]');
  const parsed = Number(metaTag === null || metaTag === void 0 ? void 0 : metaTag.content);
  return Number.isNaN(parsed) ? undefined : parsed;
}
export function getPortalInstanceId() {
  const metaTag = document.querySelector('meta[name="x-hs-portals-instance-id"]');
  const parsed = Number(metaTag === null || metaTag === void 0 ? void 0 : metaTag.content);
  return Number.isNaN(parsed) ? undefined : parsed;
}
export const getPortalHublet = () => {
  const metaTag = document.querySelector('meta[name="x-hs-portals-hublet"]');
  return metaTag === null || metaTag === void 0 ? void 0 : metaTag.content;
};
export const getPortalEnv = () => {
  const metaTag = document.querySelector('meta[name="x-hs-portals-env"]');
  return metaTag === null || metaTag === void 0 ? void 0 : metaTag.content;
};
export const getIsPortalDeployed = () => {
  const metaTag = document.querySelector('meta[name="x-hs-portals-deployed"]');
  return (metaTag === null || metaTag === void 0 ? void 0 : metaTag.content) === 'true';
};
const isThemePreview = new URLSearchParams(window.location.search).get('isPortalPreview') === 'true';
export function getIsThemePreview() {
  return isThemePreview;
}
const previewJwt = typeof window === 'undefined' ? undefined : (_URLSearchParams$get = new URLSearchParams(window.location.hash.replace(/^#/, '')).get('previewJwt')) !== null && _URLSearchParams$get !== void 0 ? _URLSearchParams$get : undefined;

/**
 * The preview JWT is read from `window.location.hash` once at module load
 * and cached for the lifetime of the page — subsequent hash changes are not
 * picked up.
 */
export function getPreviewJwt() {
  return previewJwt;
}
export const setPortalRuntimeGlobals = () => {
  if (typeof window === 'undefined') {
    return;
  }
  const portalEnv = getPortalEnv();
  const portalHublet = getPortalHublet();
  const portalDeployed = getIsPortalDeployed();
  const windowWithGlobals = window;
  if (portalEnv) {
    windowWithGlobals.ENV = portalEnv;
  }
  if (portalHublet) {
    windowWithGlobals.HUBLET = portalHublet;
  }
  if (portalDeployed) {
    windowWithGlobals.DEPLOYED = 'true';
  }
};